const initialState = {
    dataRefDssd:[],
    dataDssd:[],
    dataDssdFinal:[],
}

const sipdWalidataReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'MODAL_SIPD_WALIDATA':
            return { ...state, modalSipdWalidata: action.payload }
        case 'DATA_REF_DSSD':
            return { ...state, dataRefDssd: action.payload }
        case 'DATA_DSSD':
            return { ...state, dataDssd: action.payload }
        case 'DATA_DSSD_FINAL':
            return { ...state, dataDssdFinal: action.payload }
        case 'RESET_FORM_SIPD_WALIDATA':
            return { ...state, formSipdWalidata: initialState.formSipdWalidata }
        case 'FORM_SIPD_WALIDATA':
            return {
                ...state,
                formSipdWalidata: {
                    ...state.formSipdWalidata,
                    [action.formType]: action.formValue
                }
            }
        default:
            return state
    }
}

export default sipdWalidataReducer;